import { api } from './api';
import axios from 'axios';

export const checkinService = {
    getCheckins: async () => {
        const response = await api.get('/checkins');
        return response.data;
    },
    create: async (checkInData) => {
        try {
            const response = await api.post('/checkins', checkInData);
            return response.data;
        } catch (error) {
            console.error('Error creating check-in:', error);
            throw error;
        }
    },
    
    getForEvent: (eventId) => {
        return api.get(`/checkins/event/${eventId}`);
    },
    
    getMemberCheckin: async (eventId) => {
        try {
            const response = await api.get(`/checkins/event/${eventId}/member`);
            return response.data;
        } catch (error) {
            // Silently handle missing check-in data (404s are expected for events without check-ins)
            if (error.response?.status === 404) {
                return null; // Return null instead of throwing
            }
            // Only log non-404 errors
            console.error('Error fetching check-in status:', error);
            throw error;
        }
    },
    
    update: async (checkinId, checkinData) => {
        try {
            const response = await api.put(`/checkins/${checkinId}`, {
                business_score: checkinData.business_score,
                personal_score: checkinData.personal_score,
                health_score: checkinData.health_score,
                comments: checkinData.comments,
                attending: checkinData.attending,
                has_visitors: checkinData.has_visitors || false,
                visitor_names: checkinData.visitor_names || null,
                has_substitute: checkinData.has_substitute || false,
                substitute_name: checkinData.substitute_name || null
            });
            return response.data;
        } catch (error) {
            console.error('Error updating check-in:', error);
            throw error;
        }
    },
    
    delete: (id) => {
        return api.delete(`/checkins/${id}`);
    },
    
    checkIn: async (eventId) => {
        try {
            const response = await api.post(`/checkins/events/${eventId}`);
            return response.data;
        } catch (error) {
            console.error('Error checking in:', error);
            throw error;
        }
    },
    
    getEventCheckIns: async (eventId) => {
        try {
            const response = await api.get(`/checkins/event/${eventId}/heatmap`);
            return response.data;
        } catch (error) {
            console.error('Error fetching heatmap:', error);
            throw new Error('Failed to fetch event check-ins');
        }
    },

    // Token-based check-in methods (no auth required)
    validateCheckinToken: async (token) => {
        try {
            // Create a separate axios instance without auth headers
            const tokenApi = axios.create({
                baseURL: process.env.VUE_APP_API_URL || '',
                timeout: 10000
            });
            
            const response = await tokenApi.get(`/checkins/token/${token}`);
            return response.data;
        } catch (error) {
            console.error('Error validating check-in token:', error);
            throw error;
        }
    },

    submitCheckinWithToken: async (token, checkinData) => {
        try {
            // Create a separate axios instance without auth headers
            const tokenApi = axios.create({
                baseURL: process.env.VUE_APP_API_URL || '',
                timeout: 10000
            });
            
            const response = await tokenApi.post(`/checkins/token/${token}`, checkinData);
            return response.data;
        } catch (error) {
            console.error('Error submitting check-in with token:', error);
            throw error;
        }
    }
}; 